import React, { useState } from 'react';
import { GetAllCustomerParents_getAllCustomerParents as CustomerParent } from '../../../types/schemaTypes';
import './CustomerParentItem.scss';
import DeleteModal from '../../JobProfile/DeleteModal';

interface CustomerParentItemProps {
    customerParent: CustomerParent;
    index: number;
    canEditCustomerParents: boolean;
    onEditClick: (customerParent: CustomerParent) => void;
    onDelete?: (record: any) => void;
}

const CustomerParentsItem = ({
    customerParent,
    index,
    onEditClick,
    onDelete,
    canEditCustomerParents,
}: CustomerParentItemProps): React.ReactElement => {
    const { customerName, extSystemIdentifier, enabled } = customerParent;
    const isOdd = index % 2 == 1;
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const containerStyle = `CustomerParentsItem-Bottom-Container ${!isOdd &&
        'CustomerParentsItem-Bottom-Container-With-Background'}`;
    const handleDelete = () => {
        onDelete && onDelete(customerParent);
        setDeleteConfirm(false);
    };

    return (
        <div className={containerStyle}>
            <div className="CustomerParentsItem-List-Header">{customerName}</div>
            <div className="CustomerParentsItem-List-Header">{extSystemIdentifier}</div>
            <div className="CustomerParentsItem-List-Header">{enabled ? 'Active' : 'Inactive'}</div>
            {!canEditCustomerParents && <div className="GridViewItem-List-Header"></div>}
            {canEditCustomerParents && (
                <div className="GridViewItem-List-Header">
                    {canEditCustomerParents && (
                        <div
                            onClick={() => onEditClick(customerParent)}
                            className={` ${
                                canEditCustomerParents
                                    ? 'GridViewItem-Edit-Container'
                                    : 'GridViewItem-Edit-Container-Disable'
                            }`}
                        >
                            <i className="material-icons CustomerParentsItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )}
                    &nbsp;|&nbsp;
                    {canEditCustomerParents && onDelete && (
                        <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-Edit-Container'}`}>
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    )}
                </div>
            )}
            <DeleteModal
                show={deleteConfirm}
                name={'customerParent'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default CustomerParentsItem;

